// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1iV_D","cell":"ColumnAccessor_cell__1WcWQ","firstCellAccent":"ColumnAccessor_firstCellAccent__2wDH9"};